 
import API from "../../../api/axiosClient";
import {
    DashboardDto,
    WebsiteVisitDto
} from "../types/analyticsTypes";

export const logVisit = async (
    dto: WebsiteVisitDto
) => {

    await API.post(
        "/analytics/visit",
        dto
    );

};

export const getDashboard = async () => {

    const response =
        await API.get<DashboardDto>(
            "/analytics/dashboard"
        );

    return response.data;
};